// countItem.js
const countItem = (artworks) => artworks.length;

module.exports = countItem;
